import type { VisualEffect } from '../tilemap/types';

export class CastTargetEffect implements VisualEffect {
  private readonly x: number;
  private readonly y: number;
  private readonly radiusTiles: number;
  private readonly durationSeconds: number;
  private readonly tileToScreenCenter: (x: number, y: number) => { x: number; y: number };
  private readonly tileSize: number;
  private readonly strokeColor: string;
  private readonly fillColor: string;
  private elapsed = 0;

  constructor(options: {
    x: number;
    y: number;
    radiusTiles: number;
    durationSeconds: number;
    tileToScreenCenter: (x: number, y: number) => { x: number; y: number };
    tileSize: number;
    strokeColor: string;
    fillColor: string;
  }) {
    this.x = options.x;
    this.y = options.y;
    this.radiusTiles = options.radiusTiles;
    this.durationSeconds = Math.max(0.35, options.durationSeconds);
    this.tileToScreenCenter = options.tileToScreenCenter;
    this.tileSize = options.tileSize;
    this.strokeColor = options.strokeColor;
    this.fillColor = options.fillColor;
  }

  update(deltaSeconds: number): void {
    this.elapsed += deltaSeconds;
  }

  renderOverlay(ctx: CanvasRenderingContext2D): void {
    const progress = Math.min(this.elapsed / this.durationSeconds, 1);
    const center = this.tileToScreenCenter(this.x, this.y);
    const baseRadius = Math.max(0.55, this.radiusTiles + 0.25) * this.tileSize;
    const pulse = 1 + 0.08 * Math.sin(this.elapsed * Math.PI * 4);

    ctx.save();

    ctx.globalAlpha = 0.22 * (1 - progress * 0.35);
    ctx.fillStyle = this.fillColor;
    ctx.beginPath();
    ctx.arc(center.x, center.y, baseRadius, 0, Math.PI * 2);
    ctx.fill();

    ctx.globalAlpha = 0.9;
    ctx.lineWidth = this.tileSize * 0.1;
    ctx.strokeStyle = this.strokeColor;
    ctx.beginPath();
    ctx.arc(center.x, center.y, baseRadius * pulse, 0, Math.PI * 2);
    ctx.stroke();

    ctx.globalAlpha = 0.55;
    ctx.lineWidth = this.tileSize * 0.05;
    ctx.beginPath();
    ctx.arc(center.x, center.y, baseRadius * (0.7 + 0.1 * Math.cos(this.elapsed * Math.PI * 3)), 0, Math.PI * 2);
    ctx.stroke();

    ctx.restore();
  }

  isComplete(): boolean {
    return this.elapsed >= this.durationSeconds;
  }
}
